import React from "react"
import { formatDate } from "src/main/Billing/Items/helpers"
import InvoiceLink from "src/main/Billing/Links/InvoiceLink"
import PaymentMethodDescription from "src/main/Billing/Payments/PaymentMethodDescription"
import PaymentStatusBadge from "src/main/Billing/Payments/PaymentStatusBadge"

import { formatCurrencyFromMinorUnits } from "src/utils/UnitConversion"

export const buildColumns = ({ presentmentCurrency }) => [
  {
    key: "id",
    header: "Invoice",
    width: "20%",
    cardRole: "title",
    render: (invoice) => <div className="truncate">{invoice.id}</div>,
  },
  {
    key: "status",
    sortKey: "computed_status",
    header: "Status",
    sortable: true,
    cardRole: "badge",
    render: (invoice) => <PaymentStatusBadge payment={invoice} />,
  },
  {
    key: "dueDate",
    sortKey: "due_date",
    header: "Due Date",
    sortable: true,
    cardRole: "detail",
    render: (invoice) => (invoice.dueDate ? formatDate(invoice.dueDate) : "-"),
  },
  {
    key: "totalAmount",
    sortKey: "total_amount",
    header: "Total",
    sortable: true,
    cardRole: "detail",
    render: (invoice) =>
      formatCurrencyFromMinorUnits({
        amount: invoice.totalAmount,
        currency: presentmentCurrency,
      }),
  },
  {
    key: "balance",
    sortKey: "balance",
    header: "Balance",
    sortable: true,
    cardRole: "detail",
    render: (invoice) =>
      formatCurrencyFromMinorUnits({
        amount: invoice.balance,
        currency: presentmentCurrency,
      }),
  },
  {
    key: "paymentMethod",
    header: "Method",
    width: "16%",
    cardRole: "detail",
    render: (invoice) => (
      <PaymentMethodDescription paymentMethod={invoice.paymentMethod} />
    ),
  },
  {
    key: "source",
    header: "Source",
    cardRole: "subtitle",
    render: (invoice) => {
      const sourceTypeDisplay =
        invoice.sourceType === "Reservation"
          ? "Reservation"
          : invoice.sourceType
      return (
        <div>
          <span className="text-gray-900">#{invoice.sourceId}</span>
          <div className="text-xs text-gray-600">{sourceTypeDisplay}</div>
        </div>
      )
    },
  },
]

export const buildPayColumns = ({ presentmentCurrency, copy }) => {
  const formatAmount = (amount) =>
    formatCurrencyFromMinorUnits({ amount, currency: presentmentCurrency })

  return [
    {
      key: "id",
      header: copy.columns.invoice,
      width: "140px",
      cardRole: "title",
      render: (invoice) =>
        invoice.detailPath ? (
          <InvoiceLink
            invoiceId={invoice.id}
            href={invoice.detailPath}
            className="text-link block truncate"
          >
            {invoice.id}
          </InvoiceLink>
        ) : (
          <div className="truncate">{invoice.id}</div>
        ),
    },
    {
      key: "sourceType",
      header: copy.columns.type,
      width: "120px",
      cardRole: "subtitle",
    },
    {
      key: "status",
      sortKey: "computed_status",
      header: copy.columns.status,
      sortable: true,
      width: "130px",
      cardRole: "badge",
      render: (invoice) => <PaymentStatusBadge payment={invoice} />,
    },
    {
      key: "dueDate",
      sortKey: "due_date",
      header: copy.columns.dueDate,
      sortable: true,
      width: "120px",
      cardRole: "detail",
      render: (invoice) =>
        invoice.dueDate ? formatDate(invoice.dueDate) : "-",
    },
    {
      key: "totalAmount",
      sortKey: "total_amount",
      header: copy.columns.amountDue,
      sortable: true,
      width: "130px",
      headerAlign: "right",
      cellAlign: "right",
      cardRole: "detail",
      render: (invoice) => formatAmount(invoice.totalAmount),
    },
    {
      key: "amountPaid",
      header: copy.columns.amountPaid,
      width: "120px",
      headerAlign: "right",
      cellAlign: "right",
      cardRole: "detail",
      render: (invoice) => formatAmount(invoice.totalAmount - invoice.balance),
    },
    {
      key: "balance",
      sortKey: "balance",
      header: copy.columns.balanceDue,
      sortable: true,
      width: "130px",
      headerAlign: "right",
      cellAlign: "right",
      cardRole: "detail",
      render: (invoice) => formatAmount(invoice.balance),
    },
  ]
}
